import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import OauthCallback from '../views/OauthCallback.vue';
import GeovisearthOauthCallback from '../views/GeovisearthOauthCallback.vue';
import AppView from '../views/AppView.vue';
import { sso } from './sso';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    beforeEnter: sso,
  },
  {
    path: '/oauth',
    name: "oauth",
    component: OauthCallback,
  },
  {
    path: '/geovisearth-oauth',
    name: "geovisearth",
    component: GeovisearthOauthCallback,
  },
  {
    path: '/app',
    name: "app",
    component: AppView,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to, from) => {
  localStorage.setItem('preUrl', window.location.host + '/#' + from.path);
});

export default router;
